<template>
  <div>
    <loading :active.sync="busy"/>

    <!-- Input page -->
    <div v-if="!success">
      
      <!-- Header -->
      <div class="header-title">
        사용자명 찾기
      </div>

      <!-- Input -->
      <v-form @submit.prevent="submit">

        <div class="input-field">
          <div class="input-label">
            <span>{{ $t('login.email') }}</span>
            <span class="required">*</span>
          </div>
          <div>
            <v-text-field outlined flat
              v-model.trim.lazy="email"
              @input="resetError"
              @blur="$v.email.$touch()"
              :error-messages="emailErrors">
            </v-text-field>
          </div>
        </div>

        <div class="input-fields">
          <div class="input-field">
            <div class="input-label">
              <span>{{ $t('register.lastname') }}</span>
            </div>
            <div>
              <v-text-field outlined flat
                v-model.trim.lazy="lastname"
                @input="resetError">
              </v-text-field>
            </div>
          </div>

          <div class="input-field">
            <div class="input-label">
              <span>{{ $t('register.firstname') }}</span>
            </div>
            <div>
              <v-text-field outlined flat
                v-model.trim.lazy="firstname"
                @input="resetError">
              </v-text-field>
            </div>
          </div>
        </div>

        <!-- Error message -->
        <div v-if="error">
          <span class="required">
            <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
            입력하신 정보와 일치하는 사용자명이 없습니다.
          </span>
        </div>

        <!-- Actions -->
        <div class="actions">
          <v-btn block depressed type="submit"
            color="primary">
            {{ $t('actions.submit') }}
          </v-btn>
        </div>

        <!-- Links -->
        <div class="links">
          <router-link :to="{name: 'login', query: {step: 'forgot-email'}}"
            tag="div"
            class="link-element pointer-element">
            {{ $t('login.forgot_email') }}
          </router-link>
          <router-link :to="{name: 'login'}"
            tag="div"
            class="link-element pointer-element">
            {{ $t('login.back_to_login') }}
          </router-link>
        </div>
        
      </v-form>

    </div>

    <div v-else>

      <div class="header-title">
        사용자명 찾기
      </div>

      <div class="header-subtitle">
        회원님의 정보와 일치하는 사용자명입니다.
      </div>

      <div class="header-subtitle">
        {{ username }}
      </div>

      <!-- Actions -->
      <div class="actions">
        <router-link :to="{name: 'login'}"
          tag="div">
          <v-btn block depressed color="primary">
            로그인하기
          </v-btn>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      busy: false,
      firstname: "",
      lastname: "",
      email: "",
      username: "",

      success: false,
      error: false,
    }
  },

  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push(this.$t('alert.required'))
      !this.$v.email.checkEmail && errors.push(this.$t('alert.email_not_valid'))
      return errors
    },
  },

  validations: {
    email: { 
      required, 
      checkEmail: email,
    },
  },

  methods: {
    resetError() {
      if (this.error) {
        this.error = false
        this.$v.$reset()
      }
    },

    async submit() {
      this.resetError()
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.busy = true
        try {
          await this.$store.dispatch('confirm/findUsername', {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
          })
        } catch(e) {
          this.error = true
        } finally {
          if (!this.error) {
            this.success = true
            this.username = this.$store.getters['confirm/username']
          }
          this.busy = false
        }
      }
    },
  },

}
</script>

<style scoped>

  .header-title {
    padding: 20px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-subtitle {
    padding-bottom: 20px;
    font-size: 16px;
    text-align: center;
    color: #676168;
  }

  .input-fields {
    display: grid;
    grid-template-columns: 48% 48%;
    grid-column-gap: 4%;
  }

  .links {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared_components/form/ForgotUsername.vue